import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";

/**
 * Vertical right-edge tab that opens the shared RTs calendar. Styled to
 * match ``RTScheduleFab``, ``ZohoNotesBlock`` and ``CloseAtendimentoBlock``
 * — same rounded-l-2xl, py-4 px-2, vertical text layout — but anchored
 * near the TOP of the viewport (``top-6``) so it doesn't collide with
 * the centre-anchored trio.
 *
 * The Calendar tab is visible to every authenticated user (the user
 * explicitly asked "acesso a todos os utilizadores"), so this component
 * doesn't gate itself by role. If routing decides to hide the calendar
 * for a specific role, the link still lands on RoleGate which handles
 * the deny path.
 */
export default function CalendarFab({ leadConsultorId } = {}) {
  const to = leadConsultorId
    ? `/rts-calendar?consultor_id=${encodeURIComponent(leadConsultorId)}`
    : "/rts-calendar";
  return (
    <Link
      to={to}
      data-testid="calendar-fab"
      className="fixed top-6 right-0 z-40 flex flex-col items-center gap-2 py-4 px-2 rounded-l-2xl bg-card border border-r-0 border-border shadow-[0_10px_40px_-10px_rgba(15,27,44,0.14)] hover:bg-muted transition-colors group"
      title="Abrir calendário de Reuniões Técnicas"
    >
      <CalendarDays className="w-4 h-4 text-primary group-hover:scale-110 transition-transform" />
      <span
        className="text-[10px] uppercase tracking-[0.28em] font-semibold text-foreground"
        style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
      >
        Calendário
      </span>
    </Link>
  );
}
